module.exports = new __parcel__URL__("ew.414ea9a4.jpg").toString();